// @ts-nocheck
/**
 * Contact form API handler — activates when data-use-custom-api="true" on the form.
 * Wire your endpoint in the Contact — Main section settings in the theme editor.
 */
class ContactFormApi extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form || this.form.dataset.useCustomApi !== 'true') return;

    this.endpoint = this.form.dataset.apiEndpoint || '';
    this.useEcommerceApi = this.form.dataset.useEcommerceApi === 'true';
    this.alertEl = this.form.querySelector('[data-contact-alert]');
    this.phoneInput = this.form.querySelector('[data-phone-input]');
    this.phoneCountry = this.form.querySelector('[data-phone-country]');
    this.phoneE164Input = this.form.querySelector('[data-phone-e164]');
    this.setupPhoneField();
    this.form.addEventListener('submit', this.onSubmit.bind(this));
  }

  setupPhoneField() {
    if (!this.phoneInput || !this.phoneCountry || !this.phoneE164Input) return;

    window.PSPhoneField?.populateCountryOptions(this.phoneCountry);

    this.phoneInput.addEventListener('input', () => {
      this.phoneInput.classList.remove('contact-main-field-error');
      this.syncPhoneValue(false);
    });
    this.phoneCountry.addEventListener('change', () => {
      this.phoneInput.classList.remove('contact-main-field-error');
      this.syncPhoneValue(false);
    });
  }

  syncPhoneValue(markInvalid) {
    return window.PSPhoneField?.syncValue({
      phoneInput: this.phoneInput,
      phoneCountry: this.phoneCountry,
      phoneE164Input: this.phoneE164Input,
      markInvalid,
      errorClass: 'contact-main-field-error'
    }) ?? { valid: false, e164: '' };
  }

  requestTarget() {
    if (this.useEcommerceApi) {
      const api = window.PSEcommerceApi;
      if (!api) return null;
      return {
        endpoint: api.url('/v1/storefront/contact-us'),
        headers: api.headers()
      };
    }

    if (!this.endpoint) return null;

    return {
      endpoint: this.endpoint,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-api-key': 'uoirweuorudlfjlsd'
      }
    };
  }

  async onSubmit(event) {
    const target = this.requestTarget();
    if (!target) {
      event.preventDefault();
      this.showMessage('API endpoint is not configured yet.', 'error');
      return;
    }

    event.preventDefault();
    const submitBtn = this.form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    const phoneState = this.syncPhoneValue(true);
    if (!phoneState.valid) {
      this.showMessage('Please enter a valid phone number for the selected country.', 'error');
      if (submitBtn) submitBtn.disabled = false;
      return;
    }

    const payload = {
      name: this.form.querySelector('[name="contact[name]"]')?.value || '',
      email: this.form.querySelector('[name="contact[email]"]')?.value || '',
      phone: this.phoneE164Input?.value || '',
      message: this.form.querySelector('[name="contact[body]"]')?.value || ''
    };

    try {
      const response = await fetch(target.endpoint, {
        method: 'POST',
        headers: target.headers,
        body: JSON.stringify(payload)
      });

      if (!response.ok) throw new Error('Request failed');

      const thankYouUrl = this.form.dataset.thankYouUrl || '/pages/thank-you';
      const separator = thankYouUrl.includes('?') ? '&' : '?';
      window.location.href = `${thankYouUrl}${separator}source=contact-us`;
    } catch (error) {
      this.showMessage(this.form.dataset.errorMessage || 'Something went wrong. Please try again later.', 'error');
    } finally {
      if (submitBtn) submitBtn.disabled = false;
    }
  }

  showMessage(text, type) {
    let el = this.alertEl;
    if (!el) {
      el = this.querySelector('.contact-main-form-alert');
    }
    if (!el) {
      el = document.createElement('div');
      el.className = 'contact-main-form-alert';
      el.setAttribute('role', 'alert');
      el.setAttribute('aria-live', 'polite');
      this.form.prepend(el);
    }
    el.hidden = false;
    el.className = `contact-main-form-alert contact-main-form-alert--${type}`;
    el.textContent = text;
    el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
}

if (!customElements.get('contact-form-api')) {
  customElements.define('contact-form-api', ContactFormApi);
}
